<template>
	<div class="module-active-indication flex-centerize flex-row" :class="{ on: isActive, disabled: isDisabled }">
		<v-menu
			offset-y
			nudge-bottom="10"
			nudge-left="12"
			min-width="110"
			:disabled="isDisabled"
			v-model="menu"
			attach=".module-active-indication"
		>
			<template v-slot:activator="{ on, attrs }">
				<div v-bind="attrs" v-on="on" class="flex-centerize flex-row">
					<template v-if="!loadingIsActive">
						<div class="indic mr-1"></div>
						<span class="text font-size-md">{{ text }}</span>
						<span v-if="isEnabled">
							<v-icon style="font-size: 22px; color: #93a1ba">{{ menu ? `mdi-chevron-up` : `mdi-chevron-down` }}</v-icon>
						</span>
					</template>
					<div v-else class="text-center"><AppLoader /></div>
				</div>
			</template>
			<v-list dense>
				<v-list-item v-for="(item, index) in items" :key="index" @click="item.callback()">
					<v-list-item-title>{{ item.name }}</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { updateWorkflowIsActive } from '@/store/modules/workflows/actions';
import { hasWorkflowToggleActivePermissions } from '@/store/modules/workflows/getters';
import { mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'ModuleActiveIndication',
	props: {
		flowData: { type: Object },
	},
	computed: {
		...mapGetters([hasWorkflowToggleActivePermissions.fullPath]),
		isActive() {
			return this.flowData.is_active;
		},
		isPublished() {
			return this.flowData.is_published;
		},
		hasWorkflowToggleActivePermissions() {
			return this[hasWorkflowToggleActivePermissions.fullPath](this.flowData.id);
		},
		isDisabled() {
			return !this.isEnabled || this.loadingIsActive;
		},
		isEnabled() {
			return this.isPublished && this.hasWorkflowToggleActivePermissions;
		},
		text() {
			return this.isPublished ? this.publishedText : 'Draft';
		},
		publishedText() {
			return this.isActive ? 'Enabled' : 'Disabled';
		},
		items() {
			return [{ name: this.activeText, callback: this.toggleActivation }];
		},
		activeText() {
			return this.isActive ? 'Disable' : 'Enable';
		},
	},
	methods: {
		...mapActionsShorthand({ updateWorkflowIsActive }),
		async toggleActivation() {
			this.loadingIsActive = true;
			try {
				await this.updateWorkflowIsActive({ id: this.flowData.id, isActive: !this.isActive });
			} finally {
				this.loadingIsActive = false;
			}
		},
	},
	data() {
		return {
			menu: undefined,
			loadingIsActive: false,
		};
	},
};
</script>

<style scoped lang="scss">
.module-active-indication {
	padding: 2px 5px;
	border-radius: 8px;
	.indic {
		width: 5px;
		height: 5px;
		border-radius: 50%;
	}

	color: #5a677c;
	.indic {
		background: #5a677c;
	}

	&.on {
		color: #36dfbd;

		.indic {
			background: #36dfbd;
		}
	}
	&:not(.disabled):hover {
		border: 1px solid #e7eaf3;
	}
}
</style>
